import { useCallback } from 'react'

import AuthHelper from 'helpers/auth_helper'
import { useRootContext } from 'hooks/use_context'

const useGoogleOauth = ({ setError, onClose }) => {
  const rootContext = useRootContext()

  const handleCreateSessionSuccess = useCallback(async () => {
    onClose()
    await rootContext.onAuthSuccess()
    AuthHelper.performLoginRedirect()
  }, [onClose, rootContext.onAuthSuccess])

  const handleCreateSessionFailure = useCallback(
    (response) => {
      try {
        setError(response.responseJSON.message)
      } catch {
        setError('We are having problems processing your request, please try again later.')
      } finally {
        rootContext.setLoading(false)
      }
    },
    [setError, rootContext.setLoading]
  )

  const onOauthSuccess = useCallback(
    (oauth) => {
      const { google_token_id, instagram_auth_code, redirect_uri } = oauth
      rootContext.setLoading(true)
      setError('')
      const params = { google_token_id, instagram_auth_code, redirect_uri, client: 'desktop' }
      AuthHelper.performLogin(params, handleCreateSessionSuccess, handleCreateSessionFailure)
    },
    [rootContext.setLoading, setError, handleCreateSessionFailure, handleCreateSessionSuccess]
  )

  return { onOauthSuccess }
}

export default useGoogleOauth
